import React from 'react';
import classnames from 'classnames';
import { Modal as AntdModal, ModalProps as AntdModalProps, ModalFuncProps } from 'antd';

import './style.scss';

const PREFIX = 'music';

export interface ModalProps extends AntdModalProps {
  /** 弹窗顶部标题额外元素 */
  headerChild?: React.ReactNode;
}

function Modal(props: ModalProps) {
  const {
    title,
    headerChild,
    closable = true,
    width = 520,
    footer,
    children,
    wrapClassName,
    ...rst
  } = props;

  return (
    <AntdModal
      title={
        headerChild ? (
          <div className="modal-title">
            <div>{title}</div>
            {headerChild}
          </div>
        ) : (
          title
        )
      }
      width={width}
      closable={closable}
      footer={footer}
      wrapClassName={classnames(
        `${PREFIX}-modal`,
        {
          [`${PREFIX}-modal-no-footer`]: footer === null,
        },
        wrapClassName
      )}
      {...rst}
    >
      {children}
    </AntdModal>
  );
}

// 静态方法
Modal.info = AntdModal.info;
Modal.success = AntdModal.success;
Modal.error = AntdModal.error;
Modal.warning = AntdModal.warning;
Modal.warn = AntdModal.warning;
Modal.confirm = AntdModal.confirm;
Modal.useModal = AntdModal.useModal;
Modal.destroyAll = AntdModal.destroyAll;

export default Modal;
